import { array, boolean, object, string } from 'yup';

import { getMaxLengthErrMsg } from '@constants/validationConstants';
import { MAX_1000_LENGTH } from '@constants/validationMessages';

export const schema = object({
	backhaulAccessibilityDetails: string()
		.trim()
		.default(null)
		.nullable()
		.max(MAX_1000_LENGTH, getMaxLengthErrMsg('Details', MAX_1000_LENGTH)),
	powerSupplyAvailabilityDetails: string()
		.trim()
		.default(null)
		.nullable()
		.max(MAX_1000_LENGTH, getMaxLengthErrMsg('Details', MAX_1000_LENGTH)),
	assetSiteAvailabilityDetails: string()
		.trim()
		.default(null)
		.nullable()
		.max(MAX_1000_LENGTH, getMaxLengthErrMsg('Details', MAX_1000_LENGTH)),
	assetAccessDetails: string()
		.trim()
		.default(null)
		.nullable()
		.max(MAX_1000_LENGTH, getMaxLengthErrMsg('Details', MAX_1000_LENGTH)),
	specialImplementationIssueDetails: string()
		.trim()
		.default(null)
		.nullable()
		.max(MAX_1000_LENGTH, getMaxLengthErrMsg('Details', MAX_1000_LENGTH)),
	backhaulAccessibilityStatus: string(),
	powerSupplyAvailabilityStatus: string(),
	assetSiteAvailabilityStatus: string(),
	isAvailable: boolean(),
	specialImplementationIssuesExist: boolean(),
	assetAccessDetailsFileIds: array()
		.default([]),
	backhaulAccessibilityDetailsFileIds: array()
		.default([]),
	assetSiteAvailabilityDetailsFileIds: array()
		.default([]),
	powerSupplyAvailabilityDetailsFileIds: array()
		.default([]),
	specialImplementationIssueDetailsFileIds: array()
		.default([]),
});
